module.exports = __webpack_public_path__ + "img/initial-sampling.e277648d.png";